import { render } from "./appEduEvaLesson.vue?vue&type=template&id=725cae29&scoped=true"
import script from "./appEduEvaLesson.vue?vue&type=script&lang=js"
export * from "./appEduEvaLesson.vue?vue&type=script&lang=js"

import "./appEduEvaLesson.vue?vue&type=style&index=0&id=725cae29&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725cae29"]])

export default __exports__